module.exports = __webpack_public_path__ + "img/rule.8575cb17.svg";